import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './components/Button';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} data-id="element-0" data-mp="3fa89pae26y7h">
    {children}
  </motion.div>;
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      window.fbq('init', '790333870788238');
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToCompra = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-pink selection:text-white pb-20" data-id="element-1" data-mp="38l8hlqqlnwhd">
      {/* TOP ANNOUNCEMENT BAR */}
      <div className="bg-brand-red text-white text-center py-2 px-4 text-sm font-medium w-full" data-id="element-2" data-mp="3dirw8rr7mb9u">
        🔥 Planificacion Anual Primaria y Secundaria + 1000 actividades
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-4" data-id="element-3" data-mp="st2kinlsz5ld">
        {/* 1. HERO SECTION */}
        <section className="text-center mb-12" data-id="element-4" data-mp="34x13f0jn52b">
          <FadeIn data-id="element-5" data-mp="3ud1glcmeruc7">
            <p className="text-brand-gray sm:text-base mb-2 font-medium text-[12px]" data-id="element-6" data-mp="3udkoe0ich2ci">
              "Material educativo para docentes de ingles"
            </p>
            <h1 className="sm:text-4xl md:text-5xl font-black text-brand-pink mb-4 text-[24px]" data-id="element-7" data-mp="d2bh5dik1ru3">
              MEGAPACK TEACHER'S RESOURCE
            </h1>
            <h2 className="sm:text-2xl font-bold text-brand-navy mb-8 text-[18px]" data-id="element-8" data-mp="3gm63tp8sgt3c">
              Dejá de perder horas buscando actividades de inglés
            </h2>

            <div className="relative max-w-md mx-auto mb-8" data-id="element-9" data-mp="3qbpnuy88mszs">
              <img src="https://cdn.magicpatterns.com/uploads/oRZtonAtd6LRbvsiQ11LJG/imagen_hero.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-10" data-mp="3qdakqui0yo0t" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-11" data-mp="2swbs5b07hako">
              Todo el material organizado, listo para usar y adaptado a cada
              nivel
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-left" data-id="element-12" data-mp="1d5jb49sgzr5j">
              <h3 className="font-bold text-lg sm:text-xl mb-6 text-center text-brand-navy" data-id="element-13" data-mp="ygmxlx7n9lxj">
                👉 Acceso inmediato y organizado
              </h3>
              <ul className="space-y-4" data-id="element-14" data-mp="1r4inoj2pkflc">
                {['Comprás ahora', 'Recibís acceso automático', 'Entrás al material organizado por niveles', 'Podés descargar o usar directamente'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-base sm:text-lg" data-id="element-15" data-mp="1m4wcef6fx9f6" data-mpi={i}>
                    <span className="mr-3 text-xl text-green-500" data-id="element-16" data-mp="6qictxfz2wvs">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 2. PREGUNTA BLOCK */}
        <section className="text-center mb-12" data-id="element-17" data-mp="m5xa1b8jzj1j">
          <FadeIn data-id="element-18" data-mp="m544uep8t1li">
            <p className="text-lg mb-4 font-[600] text-[#E91E8E]" data-id="element-19" data-mp="h7c54yicwb6r">
              Si sos docente de inglés, dejame hacerte una pregunta honesta:
            </p>
            <h2 className="sm:text-3xl font-bold mb-6 text-[20px] text-[#E53E3E]" data-id="element-20" data-mp="c9u6c0y1zcch">
              ¿Sentís que preparar clases te roba demasiado tiempo… todos los
              días?
            </h2>
            <div className="space-y-4 text-base sm:text-lg text-brand-navy max-w-2xl mx-auto" data-id="element-21" data-mp="14xg8d4rmu8x8">
              <p data-id="element-22" data-mp="zwipsr2pncv7">
                Es porque cada clase te obliga a volver a buscar actividades,
                pensar dinámicas y preparar todo otra vez.
              </p>
              <p data-id="element-23" data-mp="3kob5yka0oe7x">
                Y entre clases, correcciones y planificación… terminás dedicando
                horas a algo que podría resolverse mucho más rápido.
              </p>
              <p className="font-bold text-xl mt-6" data-id="element-24" data-mp="1w4oqy4f216pl">
                Dar clases dinámicas no debería ser tan difícil.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 3. PROBLEMA BLOCK */}
        <section className="text-center mb-12" data-id="element-25" data-mp="25424p9a7ohg4">
          <FadeIn data-id="element-26" data-mp="253a9hzkj0lqd">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-[#E91E8E]" data-id="element-27" data-mp="29vjvj4iit1nd">
              El problema que muchos docentes viven todos los días:
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-8 text-left" data-id="element-28" data-mp="2ex0u2tdj8c0s">
              <ul className="space-y-4" data-id="element-29" data-mp="2jw3zwg1c6m9t">
                {['Pasás horas buscando actividades en Internet', 'Probás cosas que no funcionan', 'Improvisás clases a último momento', 'Terminás repitiendo siempre lo mismo'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base sm:text-lg" data-id="element-30" data-mp="yget81max54a" data-mpi={i}>
                    <span className="mr-3 text-brand-red font-bold text-xl" data-id="element-31" data-mp="21tokw9i859az">
                      •
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="text-xl sm:text-2xl font-bold text-brand-navy" data-id="element-32" data-mp="25snvoaqn00ac">
              Podrías dar mejores clases… si tuvieras todo listo
            </p>
          </FadeIn>
        </section>

        {/* 4. SOLUCIÓN BLOCK */}
        <section className="text-center mb-12" data-id="element-33" data-mp="2fqafnbmsmi16">
          <FadeIn data-id="element-34" data-mp="2fpiqojnpbijv">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-6" data-id="element-35" data-mp="2tii6ynvb5gsh">
              La solución: Megapack Teacher's Resource
            </h2>

            <div className="max-w-xs mx-auto mb-8" data-id="element-36" data-mp="2phya7lencf6v">
              <img src="https://cdn.magicpatterns.com/uploads/of2MgfaMbKCui6PujX43tA/d056731b-fdf6-4a44-99a4-79b8c71923fe.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-37" data-mp="33gehbdgf87pj" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto" data-id="element-38" data-mp="3i1k0jop0o9u5">
              Un sistema completo para que dejes de improvisar y entres al aula
              con todo resuelto
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto mb-10" data-id="element-39" data-mp="3d4jtpbkcf31z">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-lg font-bold text-brand-navy" data-id="element-40" data-mp="2zd57ywz1wnr8">
                <div className="flex items-center" data-id="element-41" data-mp="344wyx8m4cvhw">
                  <span className="text-2xl mr-2" data-id="element-42" data-mp="345on3yddzqy5">📂</span> Elegís el tema
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-43" data-mp="2pd4isuei3df4">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-44" data-mp="2uek8izrmi83u">⬇</span>
                <div className="flex items-center" data-id="element-45" data-mp="2ge1380ejlg5d">
                  <span className="text-2xl mr-2" data-id="element-46" data-mp="2ggn7nr64zfjd">📖</span> Usás la actividad
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-47" data-mp="2khp8udjm61nz">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-48" data-mp="30uvgssycvkn6">⬇</span>
                <div className="flex items-center text-brand-pink" data-id="element-49" data-mp="2vw0z5uc4k24n">
                  <span className="text-2xl mr-2" data-id="element-50" data-mp="2qx7ijt1jjv09">🗣</span> Aplicás la clase
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-10 font-bold text-brand-navy text-lg" data-id="element-51" data-mp="2lx31a0st6w8z">
              <div className="font-[400]" data-id="element-52" data-mp="2hy2oayx0intw">
                <span className="text-green-500" data-id="element-53" data-mp="2d62pxawlc2zf">✔</span>Sin perder tiempo
              </div>
              <div className="font-[400]" data-id="element-54" data-mp="286pwg7b7rxnv">
                <span className="text-green-500" data-id="element-55" data-mp="287hppbhc9jaz">✔</span>Sin empezar desde cero
              </div>
              <div className="font-[400]" data-id="element-56" data-mp="238y1t5j6pxfz">
                <span className="text-green-500" data-id="element-57" data-mp="235sd3regwxks">✔</span>Sin improvisar
              </div>
            </div>

            <div className="max-w-md mx-auto mb-10" data-id="element-58" data-mp="1u6x467k1h9ds"></div>
          </FadeIn>
        </section>

        {/* 5. CONTENIDO BLOCK */}
        <section className="text-center mb-12" data-id="element-59" data-mp="9pnz6sauwly1">
          <FadeIn data-id="element-60" data-mp="9qz2kr0e3rom">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-10" data-id="element-61" data-mp="dqhmpkkdzyqe">
              ¿Qué incluye el Megapack Teacher's Resource?
            </h2>

            <div className="bg-brand-pink rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-center" data-id="element-62" data-mp="iq40pw81hj09">
              <h3 className="text-xl sm:text-2xl font-black text-white mb-2" data-id="element-63" data-mp="nnw4polykvkt">
                📋 Planificación anual primaria y secundaria
              </h3>
              <p className="text-white/90 font-semibold text-lg mb-3" data-id="element-64" data-mp="3r4memeknvsrs">
                Para cada grado y año
              </p>
              <p className="text-white font-bold text-base sm:text-lg" data-id="element-65" data-mp="3w3pbvcuegup7">
                No pensés más - Tene todo el año resuelto ✔
              </p>
            </div>

            <div className="space-y-8 max-w-xl mx-auto text-left" data-id="element-66" data-mp="33gbl5whaovdj">
              {/* Bloque 1 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-67" data-mp="38eczk43s06io">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-68" data-mp="2f759n07a05e5">
                  🟣 BLOQUE 1 — BASES DEL INGLÉS
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-69" data-mp="2k4x2bwfqvvje">
                  (primer ciclo nivel primario -A1)
                </p>
                <ul className="space-y-3" data-id="element-70" data-mp="2u4e1rw4eld6x">
                  {['Saludos y presentación personal', 'Emociones', 'Familia, roles y descripciones', 'Colores primarios y secundarios', 'Números de 1 al 1000', 'Animales y hábitat', 'Días, meses, estaciones del año y clima', 'Actividades con juegos y práctica oral'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-71" data-mp="1dqe8v53z6nt6" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-lg" data-id="element-72" data-mp="1ineexg0trqka">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-73" data-mp="3ryym0z2way2s">
                  💡 Ideal para empezar desde cero y enganchar desde el primer
                  día
                </p>
              </div>

              {/* Bloque 2 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-74" data-mp="3d0moyrbm1nb3">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-75" data-mp="3d2r1fxnkrumz">
                  🟣 BLOQUE 2 — ESTRUCTURA Y COMUNICACIÓN
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-76" data-mp="349e0c8fcxmpt">
                  (segundo ciclo nivel primario - A2)
                </p>
                <ul className="space-y-3" data-id="element-77" data-mp="2z7exr0rfyttx">
                  {['Verb to be', 'Plurales', 'Artículos y preposiciones', 'Descripción de lugares', 'Rutinas diarias', 'Construcción de frases', 'Actividades y proyectos listos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-78" data-mp="26mrm806ccwb7" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-lg" data-id="element-79" data-mp="2ap4twu4nf4am">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-80" data-mp="33dk6zb47zcjb">
                  💡 Tus alumnos empiezan a entender y construir ideas
                </p>
              </div>

              {/* Bloque 3 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-81" data-mp="2tlwfja7nxvhu">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-82" data-mp="3hcjqy5gsf395">
                  🟣 BLOQUE 3 — HABLAR CON CONFIANZA
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-83" data-mp="3m5cyf13n4pox">
                  (ciclo basico nivel secundario - B1)
                </p>
                <ul className="space-y-3" data-id="element-84" data-mp="15oeystmyju1q">
                  {['Presente, pasado y futuro (simple, continuous, perfect, perfect continuous)', 'Verbos modales (can, could, may, might, must, should, will, would)', 'Conversaciones guiadas', 'Role plays listos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-85" data-mp="mr3yd5plaukp" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-lg" data-id="element-86" data-mp="11ls0qazp1cw3">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-87" data-mp="2d1p1qxkt3n9o">
                  💡 Más participación, más interacción real
                </p>
              </div>

              {/* Bloque 4 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-88" data-mp="hoo1mxkvf6id">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-89" data-mp="mmxzxh1w6n87">
                  🟣 BLOQUE 4 — INGLÉS EN LA VIDA REAL
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-90" data-mp="vmkw9ofrl2ue">
                  (ciclo superior nivel secundario - B2)
                </p>
                <ul className="space-y-3" data-id="element-91" data-mp="10l61615yoap6">
                  {['Conditional (0, 1, 2)', 'Reported speech', 'Situaciones reales e imaginarias', 'Actividades aplicadas', 'Y otras estructuras más'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-92" data-mp="1eex3aohd4sav" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-lg" data-id="element-93" data-mp="1oc1pgob7knro">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-94" data-mp="1tfklz1rxz4se">
                  💡 Tus alumnos usan el idioma, no solo lo estudian
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 7. CTA */}
        <section className="text-center mb-12" data-id="element-95" data-mp="1khs35nn0hf09">
          <FadeIn data-id="element-96" data-mp="2h4n4scybb3oh">
            <div className="max-w-md mx-auto mb-8" data-id="element-97" data-mp="2h56h9e570zv4">
              <img src="https://cdn.magicpatterns.com/uploads/6J9EmFwhUQTkRbxnGdj8bF/ChatGPT_Image_7_abr_2026,_08_31_22_p.m..png" alt="Megapack Teacher's Resource" className="w-full rounded-2xl" data-id="element-98" data-mp="2c63fc2kif9rd" />
            </div>
            <Button data-id="element-99" data-mp="2zw63i7lazvkp">👉 QUIERO RESOLVER MIS CLASES DE INGLÉS AHORA</Button>
          </FadeIn>
        </section>

        {/* 8. ANTES VS DESPUÉS */}
        <section className="mb-12" data-id="element-100" data-mp="2v4el4kcaww5n">
          <FadeIn data-id="element-101" data-mp="2v3d0pp9eaxb9">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-102" data-mp="t7xbgjx1vtnk">
              {/* Antes */}
              <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-200 text-center" data-id="element-103" data-mp="ta9tsy6q0615">
                <h3 className="text-xl font-bold text-brand-gray mb-6" data-id="element-104" data-mp="y8ut8ve5eloj">
                  Antes del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-105" data-mp="ogp1nmrt669v">
                  {['Improvisar cada clase', 'Buscar actividades en muchos lugares', 'Repetir siempre lo mismo', 'Perder horas planificando', 'Sentir que no te alcanza el tiempo'].map((item, i) => <li key={i} className="flex items-start text-brand-gray font-medium" data-id="element-106" data-mp="5icu25gjp4ge" data-mpi={i}>
                      <span className="mr-3 font-bold text-brand-red text-xl" data-id="element-107" data-mp="1uxspyj5gktoc">
                        •
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Después */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 border-2 border-brand-lightBlue text-center" data-id="element-108" data-mp="3fg3bgiefevt7">
                <h3 className="text-xl font-bold text-brand-pink mb-6" data-id="element-109" data-mp="3u4zn0pfoyqyk">
                  Después del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-110" data-mp="3pbofsn6yw864">
                  {['Clases listas para todo el año', 'Actividades organizadas', 'Más participación en el aula', 'Clases dinámicas sin esfuerzo', 'Mucho menos tiempo preparando'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold" data-id="element-111" data-mp="bz4jzn8no54p" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-xl" data-id="element-112" data-mp="2dqhmy6r2c2y4">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 9. BONUS SECTION */}
        <section className="text-center mb-12" data-id="element-113" data-mp="1wtix6svgm01b">
          <FadeIn data-id="element-114" data-mp="21nn5bfggoe3z">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-4" data-id="element-115" data-mp="21n3ueip8apzg">
              Además recibís estos BONUS
            </h2>
            <div className="inline-block bg-brand-pink text-white px-4 py-1 rounded-full text-sm font-bold mb-10 uppercase tracking-wide" data-id="element-116" data-mp="18xy4p37nyg2w">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>

            <div className="space-y-12 max-w-sm mx-auto" data-id="element-117" data-mp="1iw45tilnbi6p">
              {/* Bonus 1 - All About Me */}
              <div data-id="element-118" data-mp="1nuxix9x0t76c">
                <div className="mb-3" data-id="element-119" data-mp="1nvgy4ivadhgo">
                  <img src="https://cdn.magicpatterns.com/uploads/27ugRgbUzLCNJRSJfQK1gw/b2c35ba1-3fa9-4a8c-a2a5-992dcf377af2.png" alt="All About Me Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-120" data-mp="1nwidgzjc4q47" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-121" data-mp="notnwgfyo328">
                  BONUS 1 — All About Me
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-122" data-mp="dw5ulvo6wh89">
                  Para primeras semanas de clases.
                </p>
              </div>

              {/* Bonus 2 - Songs */}
              <div data-id="element-123" data-mp="3zjd9gv2o8az">
                <div className="mb-3" data-id="element-124" data-mp="3zt1p00gy7ek">
                  <img src="https://cdn.magicpatterns.com/uploads/f7RGCtUG1cTVU3Jy5iZ6SK/13bb7ca3-374b-4bd7-bea3-1c0f65d7a102.png" alt="Songs Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-125" data-mp="3woq3hkoc9dv" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-126" data-mp="1pccm06y9f0s2">
                  BONUS 2 — Songs for English Class
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-127" data-mp="1kdsyw37xjiy4">
                  Canciones con actividades listas para usar en clase.
                </p>
              </div>

              {/* Bonus 3 - Flashcards */}
              <div data-id="element-128" data-mp="27919u9eju9ve">
                <div className="mb-3" data-id="element-129" data-mp="27alt32vey6dy">
                  <img src="https://cdn.magicpatterns.com/uploads/iEntfU5GSkNfruiEqjhTej/927ee79f-f956-46ea-9e0b-d42032277b10.png" alt="Flashcards Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-130" data-mp="22grak2rjnxgg" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-131" data-mp="1ogqf52u1ti8d">
                  BONUS 3 — Flashcards Ready to Use
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-132" data-mp="1ejlpuu4wp6nc">
                  Tarjetas listas para imprimir y usar directamente.
                </p>
              </div>

              {/* Bonus Especial - Halloween */}
              <div data-id="element-133" data-mp="38x3eylkymbkh">
                <div className="inline-block bg-brand-red text-white px-3 py-1 rounded-full text-xs font-bold mb-3 uppercase tracking-wide" data-id="element-134" data-mp="38yoaoej0g0jx">
                  🎃 BONUS ESPECIAL DE REGALO
                </div>
                <div className="mb-3" data-id="element-135" data-mp="3lew9we45dk1d">
                  <img src="https://cdn.magicpatterns.com/uploads/t8FRbCtHPsZuqouaVWHshP/8484d9bf-bd1e-4bd3-9485-47d63a86bb6c.png" alt="Halloween Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-136" data-mp="3ldunjdholb4c" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-137" data-mp="32h37dcxfrc4i">
                  🎃 BONUS ESPECIAL — Halloween Activity Pack
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-138" data-mp="37f4se3ef9lim">
                  Pack completo de actividades temáticas de Halloween:
                  vocabulario, juegos, worksheets y dinámicas listas para usar
                  en clase. Ideal para hacer de octubre un mes divertido y
                  educativo.
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* PACK PREMIUM - English for Specific Purposes */}
        <section className="text-center mb-12" data-id="element-139" data-mp="3t6fkzztutort">
          <FadeIn data-id="element-140" data-mp="3t9tm74qs7rxo">
            <div className="inline-block bg-brand-red text-white px-4 py-1 rounded-full text-sm font-bold mb-6 uppercase tracking-wide" data-id="element-141" data-mp="bz28v7q6mjk0">
              ⭐ megaPACK especifico
            </div>

            <div className="max-w-sm mx-auto mb-8" data-id="element-142" data-mp="3fg2e80sp8g42">
              <img src="https://cdn.magicpatterns.com/uploads/eN7fLbJoMX4hB73WpcaZiF/ChatGPT_Image_1_may_2026,_02_38_29_p.m._-_Editado.png" alt="English for Specific Purposes" className="w-full object-contain rounded-xl" data-id="element-143" data-mp="3fgkh3g9v9sky" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-3" data-id="element-144" data-mp="3kdkpvyy3p9fr">
              ENGLISH FOR SPECIFIC PURPOSES
            </h2>
            <p className="text-base sm:text-lg text-brand-navy font-semibold mb-8 max-w-xl mx-auto" data-id="element-145" data-mp="2rqhvnj0gjkvb">
              Aprendé el inglés que realmente necesitás para tu trabajo
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-146" data-mp="1bz5s0ns4movt">
              <ul className="space-y-4" data-id="element-147" data-mp="xa9n2zld9rzf">
                {['Inglés para Negocios', 'Inglés para Negocios 2', 'Inglés Comercio Internacional', 'Inglés Turismo y Atención al Cliente', 'Inglés Área de la Salud'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-148" data-mp="1uwyuxq2r2yt7" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-149" data-mp="1kzu6fjlfmr98">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés para Adultos */}
        <section className="text-center mb-12" data-id="element-150" data-mp="9lgmuqxpoxz0">
          <FadeIn data-id="element-151" data-mp="prtkrgcg40zd">
            <div className="max-w-sm mx-auto mb-8" data-id="element-152" data-mp="psbpl1d6bniw">
              <img src="https://cdn.magicpatterns.com/uploads/2qWmDEerAXJm77yTwGoWhg/345a4f15-4ee3-490b-9f50-ea85f910e184.png" alt="Inglés para Adultos" className="w-full object-contain rounded-xl" data-id="element-153" data-mp="pt4q3kljhgsl" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-6" data-id="element-154" data-mp="b48ghj3u3vpv">
              INGLÉS PARA ADULTOS
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-155" data-mp="18oblgn99vb7r">
              <ul className="space-y-4" data-id="element-156" data-mp="13prycjixztdt">
                {['Inglés básico e intermedio aplicado a situaciones reales para adultos.', 'Actividades prácticas y visuales listas para usar', 'Enfoque en comunicación real: hablar, entender y responder con confianza'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-157" data-mp="3fgcdhmwclfsr" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-158" data-mp="1z0ohvj0hqoig">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* English for Travelers */}
        <section className="text-center mb-12" data-id="element-159" data-mp="28s2la1vkc8gv">
          <FadeIn data-id="element-160" data-mp="2dpuohs1nrh0d">
            <div className="max-w-sm mx-auto mb-8" data-id="element-161" data-mp="2dqduqbhy4gyk">
              <img src="https://cdn.magicpatterns.com/uploads/naDHg6DzACqubKqfBF92XE/e86f32be-d4ae-4105-82b5-58cf72977ba4.png" alt="English for Travelers" className="w-full object-contain rounded-xl" data-id="element-162" data-mp="2droxc7znnio3" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-6" data-id="element-163" data-mp="2rou3s93a6jjv">
              ENGLISH FOR TRAVELERS
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-164" data-mp="xbcn961ammyc">
              <ul className="space-y-4" data-id="element-165" data-mp="20m8mzdxu1v1p">
                {['Inglés práctico para viajes y situaciones reales alrededor del mundo.', 'Actividades visuales y conversaciones listas para usar.', 'Enfoque en comunicación real: hablar, entender y viajar con más confianza.'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-166" data-mp="24mip2fii81ba" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-167" data-mp="2emt485o3nit3">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés Técnico Agro */}
        <section className="text-center mb-12" data-id="element-168" data-mp="2ocmbwvl4fds2">
          <FadeIn data-id="element-169" data-mp="32b2hgj78yy8m">
            <div className="max-w-sm mx-auto mb-8" data-id="element-170" data-mp="32cdocrvzom3y">
              <img src="https://cdn.magicpatterns.com/uploads/cTF1fTR6Lex2JA142kZvyT/d0b1aeba-c187-494d-b90d-f2525b86500c.png" alt="Inglés Técnico Agro" className="w-full object-contain rounded-xl" data-id="element-171" data-mp="2xciz0srv44l0" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-6" data-id="element-172" data-mp="3lvb64fzqj8lq">
              INGLÉS TÉCNICO AGRO
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-173" data-mp="3byooe02pgxnx">
              <p className="text-brand-navy font-medium text-base" data-id="element-174" data-mp="2y79swtrm33zz">
                Para docentes de secundaria técnica con orientación agropecuaria
                que buscan enseñar inglés de forma práctica, clara y aplicable
                al mundo real.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* Inglés Técnico Informática */}
        <section className="text-center mb-12" data-id="element-175" data-mp="2t6domf3clfu1">
          <FadeIn data-id="element-176" data-mp="2fa09vdq77sj9">
            <div className="max-w-sm mx-auto mb-8" data-id="element-177" data-mp="2f9h0ilem6cgu">
              <img src="https://cdn.magicpatterns.com/uploads/dGvhgRfdPgDcDigyXHEogq/Technical_English_for_Information_Technology.png" alt="Inglés Técnico Informática" className="w-full object-contain rounded-xl" data-id="element-178" data-mp="2jb29hvo126lr" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-3" data-id="element-179" data-mp="2prlwznecv0jg">
              INGLÉS TÉCNICO INFORMÁTICA
            </h2>
            <p className="text-base sm:text-lg text-brand-navy font-semibold mb-8 max-w-xl mx-auto" data-id="element-180" data-mp="2krzjdcum7ia4">
              Comunicate en inglés en situaciones reales del mundo IT
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-181" data-mp="2bzfq6rx3e5wo">
              <ul className="space-y-4" data-id="element-182" data-mp="272fkwj82h76m">
                {['Vocabulario técnico esencial', 'Comunicación en situaciones reales', 'Seguridad y buenas prácticas', 'Documentación, tickets y casos de soporte', 'Preparación para el mundo laboral IT'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-183" data-mp="8k3sonw5l3ed" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-184" data-mp="cn8qwe97aix7">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés Técnico Programación */}
        <section className="text-center mb-12" data-id="element-185" data-mp="3l20lftkz9nhr">
          <FadeIn data-id="element-186" data-mp="3kz4mc1xe8srq">
            <div className="max-w-sm mx-auto mb-8" data-id="element-187" data-mp="3pzsnhgfc6pzo">
              <img src="https://cdn.magicpatterns.com/uploads/776yzjJBmCXJ64T5KH9AZD/74807627-8ff8-42a4-91a2-1458df8c4f59.png" alt="Inglés Técnico Programación" className="w-full object-contain rounded-xl" data-id="element-188" data-mp="3q0lk3okkzz43" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-3" data-id="element-189" data-mp="329om7fpmf2bu">
              INGLÉS TÉCNICO PROGRAMACIÓN
            </h2>
            <p className="text-base sm:text-lg text-brand-navy font-semibold mb-8 max-w-xl mx-auto" data-id="element-190" data-mp="3777zacal1927">
              Comunica, desarrolla y crece en el mundo del software
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-191" data-mp="2lwnn8vbj4l01">
              <ul className="space-y-4" data-id="element-192" data-mp="2811q20v56uwj">
                {['Comunicación profesional en inglés', 'Vocabulario técnico: claves del desarrollo', 'Lectura y escritura de documentación técnica', 'Trabajo en equipo internacional en proyectos reales', 'Procesos y herramientas del desarrollo profesional', 'Tecnologías actuales: IA, Cloud, Git y más'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-193" data-mp="1t7zxonjqz9go" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-194" data-mp="1k8cv3yfa7xm1">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés Técnico Automotriz */}
        <section className="text-center mb-12" data-id="element-195" data-mp="vqunn4twu9u2">
          <FadeIn data-id="element-196" data-mp="19pc3yhhhkk1y">
            <div className="max-w-sm mx-auto mb-8" data-id="element-197" data-mp="19puac6xv4enl">
              <img src="https://cdn.magicpatterns.com/uploads/fLMyJPCvvV7e3ivDKmvpfb/Technical_English_for_Automotive_Technology.png" alt="Inglés Técnico Automotriz" className="w-full object-contain rounded-xl" data-id="element-198" data-mp="15m62ro98dj2c" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-3" data-id="element-199" data-mp="1tc0cvy260tiw">
              INGLÉS TÉCNICO AUTOMOTRIZ
            </h2>
            <p className="text-base sm:text-lg text-brand-navy font-semibold mb-8 max-w-xl mx-auto" data-id="element-200" data-mp="1oei17zwrk077">
              Comunicate en inglés en el taller, en la industria y en tu futuro
              profesional
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-201" data-mp="1xfojadf29j2k">
              <ul className="space-y-4" data-id="element-202" data-mp="uycnj4kj8l68">
                {['Vocabulario esencial', 'Situaciones reales del taller', 'Seguridad y buenas prácticas', 'Motores, frenos, diagnóstico, sistema eléctrico y mantenimiento', 'Preparación para el mundo laboral'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-203" data-mp="1dqf6wnok6fk6" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-204" data-mp="1nolad9q0jtr5">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* Inglés Técnico Automatización Industrial */}
        <section className="text-center mb-12" data-id="element-205" data-mp="3piu9pd4me86w">
          <FadeIn data-id="element-206" data-mp="3tj4g2qwbr0ma">
            <div className="max-w-sm mx-auto mb-8" data-id="element-207" data-mp="3til7i0skdokx">
              <img src="https://cdn.magicpatterns.com/uploads/dGS3t8cSenYQ1mr39d7m1Q/Technical_English_for_Industrial_Automation.png" alt="Inglés Técnico Automatización Industrial" className="w-full object-contain rounded-xl" data-id="element-208" data-mp="3lyae3dl2dt20" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-brand-pink mb-3" data-id="element-209" data-mp="387p0a3agw9az">
              INGLÉS TÉCNICO AUTOMATIZACIÓN INDUSTRIAL
            </h2>
            <p className="text-base sm:text-lg text-brand-navy font-semibold mb-8 max-w-xl mx-auto" data-id="element-210" data-mp="8pxskq642urr">
              Comunicate en el lenguaje de la industria del presente y del
              futuro
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-211" data-mp="3vykqwx36sygn">
              <ul className="space-y-4" data-id="element-212" data-mp="3qzzrgzvreit9">
                {['Vocabulario técnico esencial', 'Comunicación en situaciones reales', 'Seguridad en la industria', 'Procesos, control y automatización', 'Preparación para el mundo laboral'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base" data-id="element-213" data-mp="c2342tu5dm8i" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-lg" data-id="element-214" data-mp="2a741d8i3m1n">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 10. ACCESO BLOCK */}
        <section className="text-center mb-12" data-id="element-215" data-mp="uyum6zxydvaz">
          <FadeIn data-id="element-216" data-mp="gzv3sa11acn9">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-217" data-mp="h0eg9b7x08tw">
              Accedé ahora al sistema completo listo para usar todo el año
            </h2>
            <Button onClick={() => document.getElementById('compra')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-218" data-mp="31q3rle9etchu">
              👉 ACCEDE AL MEGAPACK HOY
            </Button>
          </FadeIn>
        </section>

        {/* 11. RESULTADO FINAL */}
        <section className="text-center mb-12" data-id="element-219" data-mp="2u5jdnizmw20m">
          <FadeIn data-id="element-220" data-mp="3862jcjgmmvzm">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-221" data-mp="386m3m6tr1wgt">
              El resultado para vos como docente
            </h2>

            <div className="bg-white border-2 border-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-6 text-left" data-id="element-222" data-mp="337sne6n2vrcy">
              <ul className="space-y-4" data-id="element-223" data-mp="2ff2hae1uw2al">
                {['Ahorrar horas de planificación', 'Tener clases listas en minutos', 'Lograr más participación', 'Sentirte más seguro al enseñar', 'Disfrutar más tus clases'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-lg" data-id="element-224" data-mp="1wpvuaeu14oiz" data-mpi={i}>
                    <span className="mr-3 text-green-500 text-xl" data-id="element-225" data-mp="3ru3ktgfmmppx">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <p className="font-bold text-brand-pink text-lg" data-id="element-226" data-mp="lob6p1rw1rz">
              Todo sin perder tiempo buscando material en internet.
            </p>
          </FadeIn>
        </section>

        {/* ACLARACIONES Y DETALLES */}
        <section className="mb-12" data-id="element-227" data-mp="38v7re7blefd5">
          <div className="space-y-10 max-w-xl mx-auto" data-id="element-228" data-mp="38w9exb9soubr">
            {/* 1. Aclaración */}
            <FadeIn data-id="element-229" data-mp="3dtj18i1w0pvd">
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-230" data-mp="3dv3vs7o7c8t8">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-231" data-mp="3hvmp665qtmxj">
                  ⚠️ PRIMERA ACLARACIÓN (MUY IMPORTANTE)
                </h3>
                <p className="text-brand-navy font-bold text-lg text-center mb-4" data-id="element-232" data-mp="3msmlvqgpddbz">
                  Esto no es un ebook.
                </p>
                <p className="text-brand-navy text-center mb-6" data-id="element-233" data-mp="123yrg8iwnqdo">
                  Es un sistema de recursos docentes pensado para usar en clase.
                </p>
                <div className="space-y-2 mb-6" data-id="element-234" data-mp="179lt1799xcg9">
                  <p className="text-brand-navy font-bold text-base" data-id="element-235" data-mp="17awwt72pyk7d">
                    👉 No venís a leer.
                  </p>
                  <p className="text-brand-navy font-bold text-base" data-id="element-236" data-mp="12gss6ugxeo9g">
                    👉 Venís a resolver tus clases.
                  </p>
                </div>
                <ul className="space-y-3" data-id="element-237" data-mp="tj07tbwckqf7">
                  {['Material listo para usar', 'Actividades organizadas', 'Recursos pensados para aplicar directamente'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-238" data-mp="fixt1yjc6d46" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-lg" data-id="element-239" data-mp="2dvy5stili77u">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </FadeIn>

            {/* 2. Cómo se usa */}
            <FadeIn data-id="element-240" data-mp="2x7bsyq35yvm1"></FadeIn>

            {/* 3. Flexibilidad */}
            <FadeIn data-id="element-241" data-mp="2x8myauc9cbf9">
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-242" data-mp="2jfngglp0654j">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-243" data-mp="2jdkuccqz0w53">
                  FLEXIBILIDAD TOTAL
                </h3>
                <p className="text-brand-navy text-center mb-6" data-id="element-244" data-mp="29gy9hnyna532">
                  Podés usar el contenido como quieras:
                </p>
                <ul className="space-y-3 mb-6" data-id="element-245" data-mp="2ehm1ocym0ryv">
                  {['Imprimirlo', 'Usarlo en pantalla', 'Adaptarlo a tu clase', 'Repetirlo todas las veces que quieras'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-246" data-mp="3uvc65ktn5i91" data-mpi={i}>
                      <span className="mr-3 text-green-500 text-lg" data-id="element-247" data-mp="droi7dumbyis">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="text-brand-navy font-bold text-center text-lg" data-id="element-248" data-mp="8ra87q9giei4">
                  👉 No hay límites. Es tuyo.
                </p>
              </div>
            </FadeIn>

            {/* 4. Ahorro de tiempo */}
            <FadeIn data-id="element-249" data-mp="wi6717cby9yv"></FadeIn>

            {/* 5. Acceso de por vida */}
            <FadeIn data-id="element-250" data-mp="wkiozki38kbx">
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-251" data-mp="rjuuupykbndh">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-252" data-mp="rlyxz5on0icp">
                  ACCESO DE POR VIDA + ACTUALIZACIONES
                </h3>
                <p className="text-brand-navy text-center mb-2 font-medium" data-id="element-253" data-mp="11j3mhc5ygpwo">
                  Esto es CLAVE:
                </p>
                <p className="text-brand-navy font-bold text-center text-lg mb-6" data-id="element-254" data-mp="37ctmlvp1ndb9">
                  💡 Tu acceso es de por vida.
                </p>
                <p className="text-brand-navy text-center mb-4" data-id="element-255" data-mp="1iheqo4aznj6d">Y además:</p>
                <div className="space-y-3 mb-6" data-id="element-256" data-mp="1djd6th5qnftu">
                  {[{
                  emoji: '🔄',
                  text: 'El contenido se va actualizando constantemente'
                }, {
                  emoji: '➕',
                  text: 'Se agregan nuevas actividades'
                }, {
                  emoji: '🧠',
                  text: 'Se mejora en base a lo que los docentes necesitan'
                }].map((item, i) => <div key={i} className="flex items-start text-brand-navy font-medium" data-id="element-257" data-mp="2b8ya9pbhyz8w" data-mpi={i}>
                      <span className="mr-3 text-lg" data-id="element-258" data-mp="2k8le0hrp8h54">{item.emoji}</span>
                      {item.text}
                    </div>)}
                </div>
                <p className="text-brand-navy font-bold text-center text-lg" data-id="element-259" data-mp="2yuijvebwz6nv">
                  👉 Y vos seguís accediendo a todo sin pagar de nuevo.
                </p>
              </div>
            </FadeIn>
          </div>
        </section>
      </div>

      {/* 13. PRECIO SECTION - DARK BG */}
      <section id="compra" className="scroll-mt-10" data-id="element-260" data-mp="2tuw5h1kcnkdh">
        <FadeIn data-id="element-261" data-mp="2ttcmh37b6v80">
          <div className="bg-[#1a2744] py-16 px-4" data-id="element-262" data-mp="2tx8rpqx54gwc">
            <div className="max-w-3xl mx-auto text-center" data-id="element-263" data-mp="2g2pzg8awutrr">
              <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-4" data-id="element-264" data-mp="2kuhhfug03r6a">
                Accedé ahora al Megapack Teacher's Resource completo
              </h2>
              <p className="text-brand-pink font-bold text-lg sm:text-xl italic mt-6 mb-10 max-w-xl mx-auto" data-id="element-265" data-mp="267eidjc15agu">
                Crear todo este material por tu cuenta te llevaría meses
              </p>

              {/* SINGLE OFFER CARD */}
              <div className="bg-brand-pink rounded-3xl p-6 sm:p-10 max-w-3xl mx-auto mb-10 border-2 border-brand-pink shadow-2xl shadow-brand-pink/30" data-id="element-266" data-mp="224hvhgfgis73">
                <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center" data-id="element-267" data-mp="7p2q5o0496ol">
                  {/* Mockup */}
                  <div className="flex items-center justify-center" data-id="element-268" data-mp="2v880p05szrm">
                    <img src="https://cdn.magicpatterns.com/uploads/dacV6tqxEQj1YGfwGhFLhG/MEGAPACK_COMPLETO.png" alt="Megapack Teacher's Resource" className="w-full max-w-sm object-contain" data-id="element-269" data-mp="3u3vs71mnygxl" />
                  </div>

                  {/* Contenido */}
                  <div className="text-left" data-id="element-270" data-mp="hlxjztlg2iwj">
                    <h3 className="text-white font-black text-xl sm:text-2xl mb-3 leading-tight" data-id="element-271" data-mp="hkmhdx3qjh70">
                      Megapack Teacher´s Resource
                    </h3>
                    <p className="text-white/90 text-sm mb-6 leading-relaxed" data-id="element-272" data-mp="32cpraiz4cf79">
                      TODO incluido: Primaria + Secundaria + Inglés
                      Especializado + 4 Bonus
                    </p>
                    <ul className="space-y-2 mb-8 text-sm" data-id="element-273" data-mp="1cw3v66s17yj4">
                      {['Planificación anual', '+1000 actividades primaria y secundaria', '4 BONUS de regalo', 'English for Specific Purposes', 'Inglés para Adultos', 'English for Travelers', 'Inglés Técnico Agro', 'Inglés Técnico Informática', 'Inglés Técnico Programación', 'Inglés Técnico Automotriz', 'Inglés Técnico Automatización Industrial'].map((item, i) => <li key={i} className="flex items-start text-white font-medium" data-id="element-274" data-mp="29ks1w6yarzd8" data-mpi={i}>
                          <span className="mr-2 text-yellow-300 text-base font-bold" data-id="element-275" data-mp="f6iqjvaje92h">
                            ✓
                          </span>
                          {item}
                        </li>)}
                    </ul>

                    <div className="flex items-center gap-2 mb-1" data-id="element-276" data-mp="3c3986pi7odj0">
                      <span className="text-white/70 line-through text-sm" data-id="element-277" data-mp="3q05ympuf3szd">
                        ARS $59.990
                      </span>
                      <span className="bg-yellow-400 text-brand-navy px-2 py-0.5 rounded-full text-[11px] font-black uppercase tracking-wide" data-id="element-278" data-mp="2xc0dw33d63zj">
                        50% OFF
                      </span>
                    </div>
                    <div className="text-4xl sm:text-5xl font-black text-white mb-1" data-id="element-279" data-mp="3723dim4zqg6u">
                      ARS $29.990
                    </div>
                    <p className="text-[11px] text-white/80 mb-6" data-id="element-280" data-mp="3290j6bse32pl">
                      Pago único · Acceso de por vida
                    </p>

                    <a href="https://checkout.aula-mater.online/cart/44808100053037:1" className="inline-flex items-center justify-center w-full px-6 py-4 text-base sm:text-lg font-black text-brand-pink bg-white rounded-xl hover:bg-yellow-50 shadow-md hover:shadow-lg transition-all uppercase tracking-wide" data-id="element-281" data-mp="29mxuapp6612e">
                      👉 LO QUIERO
                    </a>
                    <p className="mt-3 text-[10px] font-[500] text-white/80 text-center" data-id="element-282" data-mp="k5tz7941cs2n">
                      Tarjeta · Mercado Pago
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-[#0f1b33] rounded-3xl p-8 sm:p-10 max-w-xl mx-auto" data-id="element-283" data-mp="1crvhlicu9q4b">
                <a href="https://wa.me/5491124676057?text=Hola%20vi%20el%20Megapack%20Teacher%C2%B4s%20Resource%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg sm:text-xl font-bold text-white transition-colors duration-200 bg-brand-pink rounded-xl hover:bg-brand-darkPink shadow-md hover:shadow-lg mb-4" data-id="element-284" data-mp="ytx8oshaelw7">
                  <span className="text-center" data-id="element-285" data-mp="1kcpbe8dy3rdi">
                    <svg className="w-5 h-5 inline-block align-middle mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-286" data-mp="1kbe7m8ki2jme">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-287" data-mp="1bag3lqa2ac3t" />
                    </svg>
                    COMPRA POR WHATSAPP
                  </span>
                </a>

                <p className="text-[10px] font-[500] text-[#35C8C8] whitespace-nowrap" data-id="element-288" data-mp="8l9ivf710j2n">
                  Compra por Transferencia
                </p>

                <a href="https://drive.google.com/file/d/19vlxOeIAZPzjDhj6DK83gVgPaS-EPK_9/view?usp=drivesdk" target="_blank" rel="noopener noreferrer" className="inline-block mt-6 font-semibold text-sm underline underline-offset-4 hover:text-white transition-colors text-[#F8EA21]" data-id="element-289" data-mp="1f2mv7tm5v3k6">
                  📄 Ver muestra gratis
                </a>

                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-white text-sm sm:text-base font-medium mt-8" data-id="element-290" data-mp="zo50w1zoohc5">
                  <div data-id="element-291" data-mp="1ebq2frgwu8hy">
                    <span className="text-green-400" data-id="element-292" data-mp="1efdwqsu6iyxq">✔</span> para todos los
                    niveles
                  </div>
                  <div data-id="element-293" data-mp="1ndpjukvu7elf">
                    <span className="text-green-400" data-id="element-294" data-mp="1ncy0c8fil7bi">✔</span> acceso inmediato
                  </div>
                  <div data-id="element-295" data-mp="1jdfftdrluy97">
                    <span className="text-green-400" data-id="element-296" data-mp="1jcw0m4tcanyv">✔</span> descarga digital
                  </div>
                  <div data-id="element-297" data-mp="3p5m7utz6ygx3">
                    <span className="text-green-400" data-id="element-298" data-mp="3p75mkg578jwr">✔</span> material para
                    todo el año
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* COMPARACIÓN DIRECTA */}
      <section className="bg-[#1a2744] py-16 px-4" data-id="element-299" data-mp="3f0w3khgbf0pp">
        <FadeIn data-id="element-300" data-mp="31aito9jv5bxq"></FadeIn>
      </section>

      {/* CRÉDITO */}
      <div className="text-center py-8 px-4" data-id="element-301" data-mp="317wlc7p5eseg">
        <p className="text-brand-gray text-sm italic" data-id="element-302" data-mp="368al72gliw1e">
          Creado por{' '}
          <span className="font-bold text-brand-navy" data-id="element-303" data-mp="2rc2zfxpjhmk0">Aula Mater</span>,
          proyecto educativo enfocado en facilitar el trabajo docente
        </p>
      </div>

      {/* 14. GARANTÍA */}
      <section className="text-center py-12 px-4" data-id="element-304" data-mp="2ib4y5n6hjt54">
        <FadeIn data-id="element-305" data-mp="2icpqd65buzzt">
          <div className="max-w-xl mx-auto" data-id="element-306" data-mp="2id7v6r622mjc">
            <img src="https://cdn.magicpatterns.com/uploads/c1WiiD5wweFWiSecTG8bGZ/pasted-image.jpg" alt="Garantía 7 días" className="w-28 h-28 mx-auto mb-4 object-contain" data-id="element-307" data-mp="2n9pwti63a4rg" />
            <h2 className="text-xl sm:text-2xl font-bold text-brand-navy mb-4" data-id="element-308" data-mp="lhjxmrmcmzu5">
              Garantía de satisfacción de 7 días
            </h2>
            <div className="space-y-3 text-brand-navy" data-id="element-309" data-mp="1s9lsk4xfoahr">
              <p className="font-semibold" data-id="element-310" data-mp="1sa3vfkelpmyn">
                Queremos que estés 100% conforme con tu compra.
              </p>
              <p data-id="element-311" data-mp="1x6m0ymhr9pc1">
                Probalo sin riesgo. Si no te resulta útil, podés pedir la
                devolución
              </p>
              <p className="font-bold text-brand-pink" data-id="element-312" data-mp="261igrxvze08v">
                Comprá con total tranquilidad: tu inversión está protegida.
              </p>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* FOOTER */}
      <footer className="bg-black py-8 px-4" data-id="element-313" data-mp="2fzpvea2ss67p">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-314" data-mp="2kxzqkkoiv6tb">
          <p className="text-white text-sm font-medium" data-id="element-315" data-mp="2kxhupp5ruulx">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs leading-relaxed max-w-lg mx-auto" data-id="element-316" data-mp="qjys40wvwltr">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}